import type { AppColors } from '@squire/ui';

export interface PaymentBadgeColors {
  background: keyof AppColors;
  foreground: keyof AppColors;
}

export const getPaymentBadgeColors = (
  selected: boolean,
): PaymentBadgeColors => ({
  background: selected ? 'textPrimaryInverse' : 'textPrimary',
  foreground: selected ? 'textPrimary' : 'textPrimaryInverse',
});
